import ExcelJS from "exceljs";

export const generateXLSFile = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      // Create a new workbook and add a worksheet
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet('Generated Report');

      // Get headers and rows from the input data
      const headers = data?.headers || [];
      const rows = data?.rows || [];
      const dates = data?.dates;

      // Map headers to column definitions, including alignment and width
      const columns = headers.map((header) => ({
        header: header.header, // Column title
        key: header.key,       // Data key for the column
        width: header.width || 15, // Default width if not provided
        alignment: { horizontal: header.align || 'left' }, // Text alignment
      }));
      sheet.columns = columns;

      // Style the header row
      const headerRow = sheet.getRow(1);
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid', // Solid background color
          fgColor: { argb: 'FFb4fd69' }, // Light green background color
        };
        cell.font = {
          bold: true, // Bold font
          color: { argb: 'FF000000' }, // Black text color
        };
        cell.alignment = {
          vertical: 'middle', // Vertically centered
          horizontal: 'center', // Horizontally centered
        };
      });

      // Add data rows dynamically
      const promise = Promise.all(
        rows.map(async (row) => {
          const rowData = {};
          headers.forEach((header) => {
            rowData[header.key] = row[header.key] || ''; // Map data to headers
          });
          sheet.addRow(rowData); // Add the row to the sheet
        })
      );

      // Generate the Excel file and trigger download
      promise.then(() => {
        workbook.xlsx.writeBuffer().then(function (data) {
          const blob = new Blob([data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel file MIME type
          });
          const url = window.URL.createObjectURL(blob); // Create a download URL
          const anchor = document.createElement('a'); // Create an anchor element
          anchor.href = url;
          anchor.download = `ZOE Activites Report ${dates?.from?dates?.from:'all'}-${dates?.to?dates?.to:'all'}.xlsx`; // File name for download
          anchor.click(); // Trigger the download
          window.URL.revokeObjectURL(url); // Clean up the URL
        });
      });

      resolve(); // Resolve the promise after successful file generation
    } catch (error) {
      console.error('Error during XLS file generation:', error); // Log any errors
      reject(error); // Reject the promise on error
    }
  });
};